
import { useState } from 'react'

export default function Projects() {
  return(
    <div className='min-h-screen w-full flex flex-col relative animate-fade-in'>
      <div className="h-screen w-full overflow-auto flex items-center justify-center">
        <span className='font-jaro text-[60px]'>PROJECTS</span>
      </div>
    </div>
  )
 
}

